import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import { deleteAlert, errorAlert } from "../../../../Components/Alerts";
import { ApiLink } from "../../../../APILink/ApiLink";
import authHeader from "../../../../Auth/authHeader";
import { AiFillAppstore } from "react-icons/ai";
import { AddElementsButton } from "../../../../Components/AddElementsButton";
import { NormativGrid } from "./NormativGrid";
import CrudPageHeader from "../../../../Components/CrudPageHeader";
import ReusableServerDataGrid from "../../../../Components/ReusableServerDataGrid";
import StandardNormativViewModal from "./StandardNormativViewModal";
import { useHistory } from "react-router-dom";
import "./StandardNormativPage.scss";

export default function StandardNormativPage() {
  const history = useHistory();
  const headers = authHeader();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = useState([]);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [quickFilter, setQuickFilter] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [viewData, setViewData] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${ApiLink.API_URL}Normativi/producedArticleGrid`, {
        headers,
        params: {
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sort: JSON.stringify(sortModel),
          filter: JSON.stringify(filterModel.items),
          quickFilter: quickFilter.join(" "),
        },
      });

      setData(response?.data?.items || []);
      setRowCount(response?.data?.total || 0);
    } catch (error) {
      errorAlert(
        error?.response?.data?.message ||
          error?.response?.data?.errorMessage ||
          error?.message ||
          "Gabim në marrjen e të dhënave të normativit."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [paginationModel, sortModel, filterModel, quickFilter]);

  const handleDeleteNormativ = async (productionId) => {
    try {
      await axios.delete(`${ApiLink.API_URL}Normativi/deleteNor/${productionId}`, { headers });
      deleteAlert("Normativi u fshi me sukses.");
      fetchData();
    } catch (error) {
      errorAlert(error?.response?.data?.message || error?.message || "Normativi nuk u fshi.");
    }
  };

  const handleOpenFromGrid = (rowItem) => {
    history.push(`/produc/newNormativ/edit/${rowItem?.ArticleProductionID}`);
  };

  const handleView = async (item) => {
    const rowItem = item?.rowInfo || item;
    const articleProductionID = rowItem?.ArticleProductionID;

    if (!articleProductionID) {
      errorAlert("Nuk u gjet ID e normativit për view.");
      return;
    }

    setShowViewModal(true);
    setViewLoading(true);

    try {
      const response = await axios.get(`${ApiLink.API_URL}Normativi/articlesComponents`, {
        headers,
        params: { compoudArticleID: articleProductionID },
      });

      setViewData({
        articleProductionID,
        barcode: rowItem?.Barcode,
        articleName: rowItem?.ArticleName,
        unitName: rowItem?.UnitName,
        articleType: rowItem?.ArticleType,
        components: response?.data || [],
      });
    } catch (error) {
      setShowViewModal(false);
      errorAlert(error?.response?.data?.message || error?.message || "Gabim në marrjen e normativit.");
    } finally {
      setViewLoading(false);
    }
  };

  const baseRows = useMemo(
    () =>
      (data || []).map((item, index) => ({
        id: paginationModel.page * paginationModel.pageSize + index + 1,
        barcode: item.Barcode,
        name: item.ArticleName,
        unit: item.UnitName,
        articleType: Number(item.ArticleType) === 2 ? "Gjysëm Produkt" : "Produkt i Prodhuar",
        deleteItemId: item.ArticleProductionID,
        rowInfo: item,
      })),
    [data, paginationModel.page, paginationModel.pageSize]
  );
  const rows = baseRows;

  const handleOpenCreateNormativPage = () => {
    history.push("/produc/newNormativ");
  };

  return (
    <div className="Crud__Container SNP__page">
      <div className="SNP__content">
        <CrudPageHeader
          icon={AiFillAppstore}
          title="Normativi"
          description="Lista e normativit. Për krijim ose editim, hapet forma e dedikuar."
          tutorialUrl="https://www.youtube.com/@Accountree"
          tutorialLabel="Shiko Tutorialin"
          className="SNP__header"
          action={
            <Box className="SNP__header-actions">
              <AddElementsButton
                text="Krijo Normativ"
                icon="bi bi-plus-circle"
                className="button-68"
                onClick={handleOpenCreateNormativPage}
              />
            </Box>
          }
        />

        <ReusableServerDataGrid
          columns={NormativGrid}
          rows={rows}
          onView={handleView}
          onEdit={(item) => handleOpenFromGrid(item.rowInfo || item)}
          onDelete={handleDeleteNormativ}
          showViewAction={true}
          showPayment={false}
          height={620}
          rowCount={rowCount}
          loading={loading}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          sortModel={sortModel}
          setSortModel={setSortModel}
          filterModel={filterModel}
          setFilterModel={setFilterModel}
          quickFilter={quickFilter}
          setQuickFilter={setQuickFilter}
        />

        <StandardNormativViewModal
          show={showViewModal}
          onHide={() => {
            setShowViewModal(false);
            setViewData(null);
          }}
          data={viewData}
          loading={viewLoading}
        />
      </div>
    </div>
  );
}